import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import Swal from "sweetalert2";

export const Navbar = ({ user, searchQuery, setSearchQuery }) => {
    const { signOut } = useAuth();
    // Estado para controlar la visibilidad del buscador flotante en móviles
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

    const handleSignOut = () => {
        Swal.fire({
            html: `
                <div class="flex flex-col items-center pt-2 pb-1">
                    
                    <div class="w-14 h-14 rounded-2xl bg-red-50 border border-red-100 flex items-center justify-center text-red-500 mb-3 shadow-inner">
                        <i class="fas fa-right-from-bracket text-2xl"></i>
                    </div>
                    
                    <h3 class="text-xl font-extrabold text-slate-800 tracking-tight">¿Cerrar tu sesión?</h3>
                    <p class="text-xs text-slate-500 mt-1.5 leading-relaxed">
                        Tendrás que volver a ingresar para acceder a tus tareas.
                    </p>
                    
                    <div class="mt-3.5 px-3 py-1.5 bg-slate-100/80 rounded-xl border border-slate-200/60 flex items-center space-x-2 text-xs text-slate-700 font-semibold max-w-[260px] truncate shadow-2xs">
                        <i class="fas fa-user-circle text-slate-400 text-sm"></i>
                        <span class="truncate">${user?.email || "Usuario"}</span>
                    </div>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: '<i class="fas fa-sign-out-alt mr-1.5"></i> Sí, cerrar sesión',
            cancelButtonText: "Cancelar",
            buttonsStyling: false,
            reverseButtons: true,
            padding: "1.5rem",
            backdrop: `rgba(15, 23, 42, 0.45) backdrop-filter backdrop-blur-sm`,
            customClass: {
                popup: "rounded-3xl shadow-2xl border border-slate-100 bg-white max-w-sm",
                confirmButton: "px-4 py-2.5 rounded-xl text-xs font-bold bg-gradient-to-r from-red-500 to-rose-600 hover:from-red-600 hover:to-rose-700 text-white shadow-md shadow-red-500/25 transition-all duration-150 active:scale-95 ml-2 cursor-pointer",
                cancelButton: "px-4 py-2.5 rounded-xl text-xs font-bold bg-slate-100 hover:bg-slate-200 text-slate-600 transition-all duration-150 active:scale-95 cursor-pointer"
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                await signOut();
            }
        });
    };

    return (
        <nav className="bg-white/95 backdrop-blur-md shadow-sm border-b border-slate-200/80 sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16 gap-2 sm:gap-4">

                    {/* Logo/Título con Icono Estilizado */}
                    <div className="flex items-center flex-shrink-0 group cursor-pointer">
                        <div className="w-9 h-9 rounded-xl bg-gradient-to-tr from-blue-600 to-indigo-600 flex items-center justify-center text-white shadow-md shadow-blue-500/20 mr-2.5 transform group-hover:rotate-6 transition-transform duration-200">
                            <i className="fas fa-check-double text-sm"></i>
                        </div>
                        <div className="flex items-center">
                            <span className="text-lg sm:text-xl font-extrabold tracking-tight text-slate-800">
                                TodoList
                            </span>
                            <span className="text-[10px] sm:text-xs font-bold text-blue-600 bg-blue-50 border border-blue-200/60 px-1.5 py-0.5 rounded-md ml-1.5 tracking-wide uppercase shadow-2xs">
                                Pro
                            </span>
                        </div>
                    </div>

                    {/* Buscador Versión Desktop */}
                    <div className="flex-1 max-w-md mx-4 hidden sm:block">
                        <div className="relative group">
                            <span className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400 group-focus-within:text-blue-600 transition-colors">
                                <i className="fas fa-search text-xs sm:text-sm"></i>
                            </span>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Buscar tareas..."
                                className="w-full pl-10 pr-10 py-2 bg-slate-100/80 border border-transparent rounded-xl text-sm focus:outline-none focus:bg-white focus:border-blue-500/50 focus:ring-4 focus:ring-blue-500/10 text-slate-700 placeholder-slate-400 transition-all duration-200"
                            />
                            {searchQuery && (
                                <button
                                    onClick={() => setSearchQuery("")}
                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600 transition-colors"
                                    title="Limpiar búsqueda"
                                >
                                    <i className="fas fa-times-circle text-sm hover:scale-110 transition-transform"></i>
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Acciones de la derecha (Lupa Móvil + Usuario + Botón Salir) */}
                    <div className="flex items-center space-x-2 sm:space-x-4 flex-shrink-0">

                        {/* Botón Icono Lupa para MÓVIL */}
                        <button
                            onClick={() => setIsMobileSearchOpen(true)}
                            className="sm:hidden p-2 text-slate-500 hover:text-blue-600 hover:bg-slate-100 rounded-xl transition-all duration-150 active:scale-95"
                            title="Buscar"
                        >
                            <i className="fas fa-search text-base"></i>
                        </button>

                        {user && (
                            <div className="flex items-center space-x-2 sm:space-x-3">
                                {/* Avatar con Anillo Degradado */}
                                <div
                                    className="w-9 h-9 rounded-full bg-gradient-to-tr from-blue-600 via-indigo-500 to-violet-500 p-[2px] shadow-sm flex items-center justify-center cursor-pointer"
                                    title={user.email}
                                >
                                    <div className="w-full h-full bg-white rounded-full flex items-center justify-center">
                                        <span className="text-blue-700 text-xs font-black uppercase">
                                            {user.email?.charAt(0).toUpperCase()}
                                        </span>
                                    </div>
                                </div>

                                {/* Email del usuario (Oculto en móvil) */}
                                <span className="text-slate-700 text-xs sm:text-sm font-medium hidden md:block max-w-[140px] truncate" title={user.email}>
                                    {user.email}
                                </span>

                                {/* Botón de Cerrar Sesión (En móvil sólo icono compacto, en desktop icono + texto) */}
                                <button
                                    onClick={handleSignOut}
                                    className="p-2.5 sm:px-3.5 sm:py-2 rounded-xl bg-red-50 hover:bg-red-500 text-red-600 hover:text-white border border-red-200/80 hover:border-transparent transition-all duration-200 text-xs sm:text-sm font-semibold shadow-2xs hover:shadow-md hover:shadow-red-500/20 active:scale-95 flex items-center justify-center space-x-0 sm:space-x-2 group flex-shrink-0"
                                    title="Cerrar sesión"
                                >
                                    <i className="fas fa-right-from-bracket text-sm sm:text-sm group-hover:translate-x-0.5 transition-transform duration-150"></i>
                                    <span className="hidden sm:inline">
                                        Cerrar sesión
                                    </span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Buscador Integrado Móvil */}
            {isMobileSearchOpen && (
                <div className="sm:hidden absolute inset-0 bg-white z-50 px-3 flex items-center gap-2 border-b border-slate-200 shadow-md animate-fadeIn">
                    <button
                        onClick={() => setIsMobileSearchOpen(false)}
                        className="p-2 text-slate-500 hover:text-slate-800 rounded-xl hover:bg-slate-100 transition-colors flex-shrink-0"
                        title="Volver"
                    >
                        <i className="fas fa-arrow-left text-base"></i>
                    </button>

                    <div className="relative flex-1">
                        <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                            <i className="fas fa-search text-sm"></i>
                        </span>
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Buscar tareas..."
                            autoFocus
                            className="w-full pl-9 pr-9 py-2 bg-slate-100 border border-slate-200 rounded-xl text-sm focus:outline-none focus:bg-white focus:border-blue-500 text-slate-800 placeholder-slate-400"
                        />
                        {searchQuery && (
                            <button
                                onClick={() => setSearchQuery("")}
                                className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600"
                            >
                                <i className="fas fa-times-circle text-sm"></i>
                            </button>
                        )}
                    </div>

                    <button
                        onClick={() => {
                            setSearchQuery("");
                            setIsMobileSearchOpen(false);
                        }}
                        className="text-xs font-semibold text-blue-600 hover:text-blue-800 px-2 py-1.5 rounded-lg transition-colors flex-shrink-0"
                    >
                        Cancelar
                    </button>
                </div>
            )}
        </nav>
    );
};